import * as React from 'react';

/**
 * @description RuStoreIcon icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { RuStoreIcon } from '@sravni/design-system-icons'
 *
 * <RuStoreIcon />
 * ```
 */
const RuStoreIcon = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "RuStoreIcon", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.803 19.004c-4.15 0-6.225 0-7.514-1.266C1 16.473 1 14.436 1 10.362v-.72C1 5.568 1 3.53 2.29 2.265 3.577 1 5.652 1 9.802 1h.733c4.15 0 6.225 0 7.514 1.265 1.289 1.266 1.289 3.303 1.289 7.377v.72c0 4.074 0 6.11-1.29 7.376-1.288 1.266-3.363 1.266-7.513 1.266h-.733Z", fill: "#07F" }),
    React.createElement("path", { d: "M11.604 12.095a1.09 1.09 0 0 1-.84-1.053V5.18c0-.565.544-.98 1.105-.842l3.554.872c.494.12.84.555.84 1.052v5.863c0 .566-.544.98-1.105.843l-3.554-.872ZM4.916 14.794a1.09 1.09 0 0 1-.84-1.052V7.878c0-.565.544-.98 1.105-.842l3.554.872c.494.121.84.555.84 1.053v5.863c0 .565-.544.98-1.105.842l-3.554-.872Z", fill: "#fff" }),
    React.createElement("path", { d: "M8.26 13.445a1.09 1.09 0 0 1-.84-1.053V6.529c0-.565.543-.98 1.104-.842l3.555.871c.494.121.84.555.84 1.053v5.863c0 .565-.544.98-1.105.842l-3.554-.871Z", fill: "#fff" }),
    React.createElement("path", { d: "M10.587 14.016a.356.356 0 0 1-.272-.331l-.155-4.478a1.4 1.4 0 0 0-.96-1.203.064.064 0 0 0-.07.025.052.052 0 0 0 .012.07 1.1 1.1 0 0 1 .433.87v4.796l1.012.251ZM13.931 12.665a.354.354 0 0 1-.271-.33l-.155-4.477a1.4 1.4 0 0 0-.961-1.203.064.064 0 0 0-.07.025.052.052 0 0 0 .012.07 1.1 1.1 0 0 1 .434.87v4.797l1.011.248Z", fill: "#07F" }))));

export { RuStoreIcon };
//# sourceMappingURL=RuStoreIcon.js.map
